import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="hover:text-primary-600 transition-colors">
        首页
      </Link>
      {items.map((c) => (
        <span key={c.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {c.to ? (
            <Link to={c.to} className="hover:text-primary-600 transition-colors">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}